import { render } from "./AvastTestOverlay.vue?vue&type=template&id=35522dfa&scoped=true"
import script from "./AvastTestOverlay.vue?vue&type=script&lang=js"
export * from "./AvastTestOverlay.vue?vue&type=script&lang=js"

import "./AvastTestOverlay.vue?vue&type=style&index=0&id=35522dfa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35522dfa"

export default script